import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend";
import {basename} from './config';

const operatingSystemLanguage = navigator.language;


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    debug: true,
    lng: "en",  // or dynamically set using operating system language
    fallbackLng: "en",
    supportedLngs: ["en"],
    keySeparator: false,
    ns: ["translation"],
    defaultNS: "translation",
    interpolation: {
      escapeValue: false // React already escapes by default
    },
    backend: {
      loadPath: `${basename}/locales/{{lng}}/{{ns}}.json` // Correct path for translation files
    }
  });

  export default i18n;